import React, { useContext, useCallback } from 'react';
import { TextField, Box, InputAdornment, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import { ConfigContext } from '../config';

export const NumberField = ({ id, label, disabled, step = 1, ...props }) => {
  const { useConfig, setConfig } = useContext(ConfigContext);
  const value = useConfig(id);

  const handleChange = useCallback(
    (event) => {
      setConfig(id, event.target.value);
    },
    [id, setConfig],
  );

  const increment = useCallback(() => setConfig(id, value + step), [id, step, setConfig, value]);

  const decrement = useCallback(() => setConfig(id, value - step), [id, step, setConfig, value]);

  const startAdornment = (
    <InputAdornment position="start">
      <IconButton aria-label="decrement" size="small" onClick={decrement} disabled={disabled} edge="start">
        <RemoveIcon />
      </IconButton>
    </InputAdornment>
  );

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton aria-label="increment" size="small" onClick={increment} disabled={disabled} edge="end">
        <AddIcon />
      </IconButton>
    </InputAdornment>
  );

  return (
    <Box component="span" mr={2}>
      <TextField
        type="number"
        value={value}
        label={label}
        onChange={handleChange}
        disabled={disabled}
        step={step}
        size="small"
        margin="dense"
        style={{ maxWidth: '6rem' }}
        InputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          startAdornment: startAdornment,
          endAdornment: endAdornment,
        }}
        {...props}
      />
    </Box>
  );
};

export default NumberField;
